import { RoleCreate } from "@boark/shared/types/role-create";
import { RoleUpdate } from "@boark/shared/types/role-update";
import {
  RoleWithDetails,
  roleWithDetailsSchema,
} from "@boark/shared/types/role-with-details";
import * as z from "zod";

import {
  deleteRequest,
  request,
} from "../utils/request";
import { recordIdToId } from "../utils/record-id-to-id";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

function languageHeaders(language: string): HeadersInit {
  return {
    "Content-Type": "application/json",
    "Accept-Language": language,
  };
}

export async function getRoles(language: string): Promise<RoleWithDetails[]> {
  return request(`${API_BASE_URL}/role`, {
    schema: z.array(roleWithDetailsSchema),
    headers: languageHeaders(language),
  });
}

export async function getRole(
  id: string,
  language: string,
): Promise<RoleWithDetails> {
  return request(`${API_BASE_URL}/role/${id}`, {
    schema: roleWithDetailsSchema,
    headers: languageHeaders(language),
  });
}

export async function createRole(
  role: RoleCreate,
  language: string,
): Promise<RoleWithDetails> {
  return request(`${API_BASE_URL}/role`, {
    method: "POST",
    schema: roleWithDetailsSchema,
    headers: languageHeaders(language),
    body: role,
  });
}

export async function updateRole(
  id: string,
  role: RoleUpdate,
  language: string,
): Promise<RoleWithDetails> {
  return request(`${API_BASE_URL}/role/${id}`, {
    method: "PUT",
    schema: roleWithDetailsSchema,
    headers: languageHeaders(language),
    body: role,
  });
}

export async function deleteRole(id: string): Promise<void> {
  return deleteRequest(`${API_BASE_URL}/role/${id}`);
}

export function formatAssignedUsers(role: RoleWithDetails): string {
  if (role.assignedTo.length === 0) {
    return "";
  }

  return role.assignedTo.map((user) => user.email).join(", ");
}

export function toAssignedUserIds(userIds: string[]): string[] {
  return userIds.map((id) => (id.includes(":") ? recordIdToId(id) : id));
}
